/** Number and label formatting shared by the figure, its axes, and its readouts. */

/**
 * Enough significant figures to be honest, few enough to fit a tick label.
 * The thresholds are chosen so a slider readout never changes width as it
 * scrubs through a decade, which would make the strip jitter.
 */
export function formatValue(value: number): string {
  if (!Number.isFinite(value)) return "—";
  const magnitude = Math.abs(value);

  if (magnitude === 0) return "0";
  if (magnitude >= 1e5 || magnitude < 1e-3) return value.toExponential(2);
  if (magnitude >= 100) return value.toFixed(1);
  if (magnitude >= 1) return value.toFixed(2);
  return value.toFixed(3);
}

/** `"Position (m)"` → `"Position"`, for places where the unit is redundant. */
export const stripUnits = (label: string): string =>
  label.replace(/\s*\(.*\)\s*$/, "").trim() || "x";

export const truncate = (text: string, max: number): string =>
  text.length <= max ? text : `${text.slice(0, max - 1)}…`;
